// Supports weights 300-800

const theme = {
    font: {
        family: 'Open Sans Variable, sans-serif',
        weight: {
            extraLight: 200,
            light: 300,
            regular: 400,
            semiBold: 500,
            bold: 700,
            extraBold: 900
        },
        size: {
            small: ".75rem",
            regular: ".9rem",
            medium: "1.2rem",
            large: "1.4rem",
            extraLarge: "1.8rem"
        },
    }
}

export default theme 